import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 15000 });

// ---- Content (GET) ----
export const getInsights = () => http.get("/insights").then((r) => r.data);
export const getCapabilities = () => http.get("/capabilities").then((r) => r.data);
export const getHome = () => http.get("/home").then((r) => r.data);
export const getMagazine = () => http.get("/magazine").then((r) => r.data);
export const getBLounge = () => http.get("/blounge").then((r) => r.data);

// ---- Submissions (POST) ----
export const postContact = (payload) => http.post("/contact", payload).then((r) => r.data);
export const postNewsletter = (email) => http.post("/newsletter", { email }).then((r) => r.data);
export const postBooking = (payload) => http.post("/bookings", payload).then((r) => r.data);
export const postMembership = (payload) => http.post("/memberships", payload).then((r) => r.data);

export default http;
